import * as THREE from 'three';

function addLights(scene) {
    const ambientLight = new THREE.AmbientLight(0x404040, 1); // soft white light
    scene.add(ambientLight);

    const pointLight = getPointLight(1);
    pointLight.position.y = 10;
    scene.add(pointLight);

    const keyLight = new THREE.DirectionalLight(0xffffff, 1);
    keyLight.position.set(-100, 0, 100);
    scene.add(keyLight);

    const backLight = new THREE.DirectionalLight(0xffffff, 1);
    backLight.position.set(100, 0, -100).normalize();
    scene.add(backLight);

    function getPointLight(intensity) {
        const light = new THREE.PointLight(0xffffff, intensity);
        light.castShadow = true;

        light.shadow.mapSize.width = 1024;
        light.shadow.mapSize.height = 1024;

        return light;
    }
}

export default  addLights;